import styled from 'styled-components'

import { ButtonPlain, stylesFrom } from '@subaio/components'

import { Row } from 'components/Lists'

export const BankContainer = styled(ButtonPlain)`
	${stylesFrom(Row)};
`
